// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"f6b7b2a4","903":"c8d8951e"}[chunkId] + ".chunk.js";
};